import Vue from 'vue';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

Vue.prototype.$axios = axios;

export default axios;
